import { render, staticRenderFns } from "./offerDetect.vue?vue&type=template&id=87cac75c"
import script from "./offerDetect.vue?vue&type=script&lang=js"
export * from "./offerDetect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports